<div class="search-input-container" *transloco="let t">
    <label class="sr-only" [attr.for]="'store-chooser-search'">{{t('shared_components.store_chooser.search_placeholder')}}</label>
    <input id="store-chooser-search" type="text" class="search-input" (keyup.enter)="searchStoresByAddress()" [(ngModel)]="searchInput" [placeholder]="t('shared_components.store_chooser.search_placeholder')"/>
    <div class="action-buttons-container">
        <button [attr.aria-label]="'Clear search'" class="button-undecorated clear-button" (click)="clearSearch()">
            <span class="sr-only">{{t('shared_components.store_chooser.clear_search')}}</span>
            <cwo-icon [name]="iconNameType.close" class="icon"/>
        </button>
        <div class="separator"></div>
        <button [attr.aria-label]="'Search'" class="button-undecorated search-button" (click)="searchStoresByAddress()" [type]="'submit'">
            <cwo-icon [name]="storesLoading ? iconNameType.spinnerIcon : iconNameType.search" class="icon" [spin]="storesLoading"/>
        </button>
    </div>
</div>
<cwo-use-my-location-button 
    [ngStyle]="{'display': isMobile() ? 'flex' : 'none'}"
    [loadingSubscription]="getAddressSubscription" 
    [iconSize]="'1rem'" 
    class="location-button" 
    (clickEvent)="searchStoresByLocation()" 
    [ariaLabel]="'Use My Location'" 
    [iconName]="iconNameType.location"
    [iconColor]="'var(--primary)'"
    *transloco="let t"
>
<u class="location-text">{{t('shared_components.address_form.use_my_location')}}</u>
</cwo-use-my-location-button>
@if(locationError){
    <div class="generic-error">
        <span class="error">
          <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
          {{ locationError }}
        </span>
  </div>
}


<div class="map-container">
    <cwo-mapbox-map 
        [mapCenter]="mapCenter"
        [mapElements]="mapElements"
        [isInChangeStoreModal]="true"
        (markerClicked)="handleMarkerClicked($event)"
        [currentStorePrimaryKey]="currentStore?.primaryKey"
        [pitch]="0"
    />
</div>

@if(selectedStore){
    <div class="selected-store" *transloco="let t">
        <div class="selected-store-info-container">
            <button class="button-undecorated select-another-store-button" (click)="backToStoresList()">
                <cwo-icon [name]="iconNameType.arrow" class="back-icon"/>
                <span>{{t('shared_components.store_chooser.select_another_store')}}</span>
            </button>
            <span class="selected-store-name">{{selectedStore.name}}</span>
            <div class="store-address-container">
                <span class="store-address-label">{{t('shared_components.store_chooser.store_address')}}</span>
                <span class="store-address">{{selectedStore.address}}</span>
            </div>
            @if(orderService.order().isInitialized){
                <span class="warning-message">
                    <cwo-icon [name]="iconNameType.tooltip" class="icon"/>
                    {{t('shared_components.store_chooser.store_change_warning')}}
                </span>
            }
        </div>
        @if(shouldShowMakeFavoriteStore) {
            <div class="save-for-future-orders-container">
                <cwo-checkbox [name]="'saveForFutureOrders'" [(ngModel)]="saveForFutureOrders" [labelName]="t('shared_components.store_chooser.save_for_future_orders')">
                </cwo-checkbox>
            </div>
        }
        <div class="go-to-store-button-container">
            <button class="button-accent go-to-store-button" cwoAsyncButton [subscription]="loadingSubscription" (click)="goToStore(selectedStore)">
                {{t('shared_components.store_chooser.go_to_store')}}
            </button>
        </div>
    </div>
} @else {
    @if(searchTriggered) {
        @if(searchStoresResult.length && !noResultsTitle) {
            <div class="stores-list" *transloco="let t" [style]="{'min-height': '170px'}">
                <div class="search-results-title-container">
                    <span class="results-for-label">{{t('shared_components.store_chooser.results_for', {searchQuery: searchQueryUsed})}}</span>
                    <button class="button-undecorated clear-search-text-button" (click)="clearSearch()">
                        {{t('shared_components.store_chooser.clear_search')}}
                    </button>
                </div>
                @for (item of searchStoresResult; track item.primaryKey; let i = $index) { 
                    @if(!item.isCurrentStore){
                        <button class="button-undecorated store-item" (click)="selectStore(item)">
                            <span class="index">{{i + 1}}</span>
                            <span class="store-info-container">
                                <span class="store-name">{{ item.name }}</span>
                                <span class="store-address">{{ item.address }}</span>
                            </span>
                        </button>
                    }
                }
            </div>
        } @else {
            <div class="no-results-container" *transloco="let t">
                <div class="test-wrapper">
                <img src="../../../assets/icons/no_stores_found.png" class="no-stores-image" [alt]="'No stores found'">
     
                <div class="text-wrapper">
                    <span class="no-results-text">{{noResultsTitle}}</span>
                    <span class="try-search-different-prompt">
                        {{noResultsPrompt}}
                    </span>
                </div>

                <button class="button-accent search-again-button" (click)="clearSearch()">{{t('shared_components.store_chooser.search_again')}}</button>
            </div>
            </div>
        }
    
    } @else {
        <div class="stores-list" *transloco="let t">
            @if(currentStore){
                <span class="current-stores-title title">{{t('shared_components.store_chooser.current_store')}}</span>
                <button class="button-undecorated store-item highlighted" (click)="focusOnCurrentStore()">
                    <span class="index">{{1}}</span>
                    <span class="store-info-container">
                        <span class="store-name">{{ currentStore.name }}</span>
                        <span class="store-address">{{ currentStore.address }}</span>
                    </span>
                </button>
            }
            <span class="other-stores-title title">{{t('shared_components.store_chooser.other_stores')}}</span>
            @for (item of stores; track item.primaryKey; let i = $index) {  
                <button class="button-undecorated store-item" (click)="selectStore(item)">
                    <span class="index">{{i + 2}}</span>
                    <span class="store-info-container">
                        <span class="store-name">{{ item.name }}</span>
                        <span class="store-address">{{ item.address }}</span>
                    </span>
                </button>
            }
        </div>
    }
}

